export default __webpack_public_path__ + "img/instra6.bc80d488.jpg";